import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { createActionSettingsSchema, getFieldInfoByName } from '../collection/Util';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { redirectOptions } from '../../../../common/utils/event_constants';
import BrowserStorageLocationField from '../BrowserStorageLocationField';

export const CustomPageRedirect = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [redirectValueFrom, setRedirectValueFrom] = useState('');

  useEffect(() => {
    actionData.args.forEach((arg) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === arg.name;
      });
      if (dbParameters) {
        if (arg.name === 'redirectValueFrom') {
          if (dbParameters.value) {
            setRedirectValueFrom(dbParameters.value);
          } else setRedirectValueFrom('CUSTOM_URL');
        }
      }
    });
  }, [actionData]);

  const validateResponseDataSessionKey = (value) => {
    console.log(
      '🚀 ~ file: CollectionActionForm.js:117 ~ CollectionActionForm validateResponseDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  const handleSubmit = (values) => {
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, setFieldTouched, resetForm, values }) => {
        return (
          <Form className="form-horizontal">
            <div className="mx-auto">
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    label="Get redirect value from"
                    icon="select"
                    infoIcon={true}
                    infoDescription={'Select Where you want to get data from.'}
                  >
                    <CustomSelect
                      name={'redirectValueFrom'}
                      isMulti={false}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                        setRedirectValueFrom(value);
                      }}
                      onBlur={setFieldTouched}
                      options={redirectOptions}
                      value={redirectValueFrom}
                    />
                  </FormFieldWithLabel>
                </div>
                {redirectValueFrom === 'BROWSER_STORAGE' && (
                  <>
                    <BrowserStorageLocationField
                      fieldName={'responseDataSessionStorageLocation'}
                      values={values}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                    />
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Response Data Session Key"
                        icon="text"
                        infoIcon={true}
                        infoDescription={`Enter the key from where you want to get response data from your web browser storage.`}
                      >
                        <Field
                          type="text"
                          name="responseDataSessionKey"
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder="Response Data Session Key"
                          validate={validateResponseDataSessionKey}
                        />
                      </FormFieldWithLabel>
                      <ErrorMessage
                        name="responseDataSessionKey"
                        component="p"
                        className="text-error ml-5"
                      />
                    </div>
                  </>
                )}
                <div className="form-group">
                  <FormFieldWithLabel
                    label="Destination"
                    icon="text"
                    infoIcon={true}
                    infoDescription={'Url or Path to the url'}
                  >
                    <Field
                      name="destination"
                      type="text"
                      value={values.destination}
                      placeholder={
                        redirectValueFrom === 'CUSTOM_URL'
                          ? 'Url: Eg. https://google.com'
                          : 'Path: data.url.'
                      }
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 text-left">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-md"
                    onClick={hideModal}
                  >
                    <i className="wb webconnect-times"></i>&nbsp;Cancel
                  </button>
                </div>
                <div className="col-md-6 text-right">
                  <button type="submit" className="btn btn-theme-submit btn-md">
                    <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                    <CustomLoader loading={showLoaderForAction} />
                  </button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
